import { Directive, ElementRef, Input, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[dialog]',
  standalone: true,
})
export class DialogDirective {
  @Input() class = '';

  constructor(
    public viewContainerRef: ViewContainerRef,
    public elementRef: ElementRef<any>,
  ) {}
}
